// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
$(document).on("turbo:load", () => $("#expense_import_user_id").select2({placeholder: "インポート依頼元", allowClear: false}));
